import phaseOneChia from './phaseOneChia/phaseOneChia.js';

const printableList = [phaseOneChia, ]
export default printableList;